import {
  faDownLeftAndUpRightToCenter,
  faSpinner,
  faUpRightAndDownLeftFromCenter,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import * as _ from 'lodash'
import { AccordionTab } from 'primereact/accordion'
import { Sidebar } from 'primereact/sidebar'
import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UlAccordion from '../../../../components/ul-accordion/UlAccordion'
import { CertificateDocumentStatus } from '../../../../enums/CertificateDocumentStatus'
import {
  CertificateDocumentType,
  CertificateDocumentTypeV2,
} from '../../../../enums/CertificateDocumentType'
import { SchemeEcmType } from '../../../../enums/SchemeEcmType'
import {
  reloadCertificateDetails,
  selectCertificateList,
} from '../../../../features/certificateList/certificateListSlice'
import {
  updateProdDetailsAttachments,
  updateServiceRequestNumber,
} from '../../../../features/createCertificate/createCertificateSlice'
import CertificateListService from '../../../../services/CertificateListService'
import CloseIcon from '../../../../shared/close-icon/CloseIcon'
import { CertificateDocumentModel } from '../../../../shared/models/CertificateDocument.model'
import ULTabs from '../../../../shared/ul-tabs/ULTabs'
import {
  IAddAttachmentsRPTestReportModel,
  IPaginatedRPDocumentAttachments,
} from '../add-new-certificate/rp-library/shared/interfaces/IAddAttachmentsRPTestReportModel'
import { AddAttachmentsRPUtils } from '../add-new-certificate/rp-library/shared/utils/AddAttachmentsRPUtils'
import Actions from './Actions/Actions'
import CertificateDetailsAttachmentsV3 from './certificate-details-attachments-v3/CertificateDetailsAttachmentsV3'
import CertificateDetailsAttachments from './certificate-details-attachments/CertificateDetailsAttachments'
import CertificateDetailsRPAttachmentsV2 from './certificate-details-rp-attachments-v2/CertificateDetailsRPAttachmentsV2'
import './CertificateDetails.scss'
import classes from './CertificateDetailsV2.module.scss'
import DecisionSummary from './DecisionSummary/DecisionSummary'
import DetailsV2 from './DetailsV2/DetailsV2'
import Header from './Header/Header'
import LinkedProductsV2 from './LinkedProductsV2/LinkedProductsV2'
import Parties from './Parties/Parties'
import RevisionHistory from './RevisionHistory/RevisionHistory'
import { CertificateDetailsUtils } from './shared/CertificateDetailsUtils'
import { useCertificateDocumentRealTimeUpdates } from '../../hooks/useCertificateDocumentRealTimeUpdates'
import { useEcmUploadCompletionRefresh } from '../../hooks/useEcmUploadCompletionRefresh'
import { useSignalR } from '../../../../hooks/useSignalR'
import { DOCUMENT_TYPE_LIST } from '../../../../utils/constants/certificate.constants'
import { IAddAttachmentsRPTestSupportingDocumentModel } from '../add-new-certificate/rp-library/shared/interfaces/IAddAttachmentsRPTestSupportingDocumentModel'

interface CertificateDetailsV2Props {
  showCertificateDetails: boolean
  setShowCertificateDetails: React.Dispatch<React.SetStateAction<boolean>>
  isReadOnly: boolean
  onDeleteCertificate: () => {}
}

interface PagedAttachments {
  firstIndex: number
  hasNextPage: boolean
  hasPreviousPage: boolean
  lastIndex: number
  pageNumber: number
  total: number
  totalPages: number
  records: Partial<CertificateDocumentModel>[]
}
type AttachmentsV2Type = {
  [key: number]: Partial<PagedAttachments>
}

const initialFlyOutWidth: string = '45rem'

const isSameDocumentId = (left?: string, right?: string) =>
  !!left && !!right && left.toLowerCase() === right.toLowerCase()

const CertificateDetailsV2 = (props: CertificateDetailsV2Props) => {
  const dispatch = useDispatch()
  const { selectedCertificateId, isReloadDetails } = useSelector(selectCertificateList)
  const [details, setDetails] = useState<any>(null)
  const [certificateDetailFromE2E, setCertificateDetailFromE2E] = useState<any>(null)
  const [attachments, setAttachments] = useState<Partial<CertificateDocumentModel>[] | null>(null)
  const [attachmentsV2, setAttachmentsV2] = useState<AttachmentsV2Type | null>(null)
  const [rpAttachments, setRPAttachments] = useState<IAddAttachmentsRPTestReportModel[]>([])
  const [rpAttachmentsV2, setRPAttachmentsV2] = useState<IPaginatedRPDocumentAttachments | null>(
    null
  )
  const [decisionSummaryData, setDecisionSummaryData] = useState(null)
  const [partiesAttribute, setPartiesAttribute] = useState(null)
  const [partiesData, setPartiesData] = useState(null)

  const [isFetchingCertificateDetails, setIsFetchingCertificateDetails] = useState(false)
  const [hasCertificateBeenActive, setHasCertificateBeenActive] = useState<boolean>(false)

  const [flyoutWidth, setFlyoutWidth] = useState<string>(initialFlyOutWidth)
  const [isCOScheme, setIsCOScheme] = useState(false)
  const [schemeEcmType, setSchemeEcmType] = useState<SchemeEcmType>()
  const [isDecision, setIsDecision] = useState<boolean>(false)
  const [isAttachmentLoaded, setIsAttachmentLoaded] = useState<boolean>(false)
  const [isFetchingData, setIsFetchingData] = useState<CertificateDocumentTypeV2 | null>(null)
  const [isFetchingRPData, setIsFetchingRPData] = useState<boolean>(false)

  const attachmentsV2Documentids = attachmentsV2
    ? Object.values(attachmentsV2)
        .filter(attachment => attachment?.records != null)
        .flatMap(attachment => attachment!.records?.map(record => record.id!) || [])
    : []
  const attachmentsDocumentIds = attachments?.map(a => a.id!) ?? []
  const combinedDocumentIds = [...attachmentsDocumentIds, ...attachmentsV2Documentids]
  const hubUrl = (process.env.REACT_APP_GMAE2E_URL + '/hubs/pending_document_list') as string
  const { connection: signalRConnection } = useSignalR(hubUrl)
  useCertificateDocumentRealTimeUpdates(
    signalRConnection,
    combinedDocumentIds,
    handleCertificateDocumentUpdate
  )

  const functionHubUrl = (process.env.REACT_APP_GMAE2E_FUNC_URL + '/api') as string
  const { connection: functionSignalRConnection } = useSignalR(functionHubUrl, true)

  useEcmUploadCompletionRefresh(
    functionSignalRConnection,
    combinedDocumentIds,
    fetchCertificateDocumentById,
    handleCertificateDocumentUpdate
  )

  async function fetchCertificateDocumentById(documentId: string) {
    const response = await CertificateListService.getCertificateDocumentsByDocumentId(documentId)
    return response?.data ?? null
  }

  function handleCertificateDocumentUpdate(updatedDocument: CertificateDocumentModel) {
    setAttachmentsV2(prev => {
      if (!prev) return prev

      const newObject = _.cloneDeep(prev)

      for (const [key, value] of Object.entries(newObject)) {
        if (!value.records) continue

        value.records = value.records.map(record => {
          if (isSameDocumentId(record.id, updatedDocument.id)) {
            return { ...record, ...updatedDocument }
          }
          return record
        })
      }

      return newObject
    })

    setAttachments(prev => {
      if (!prev) return prev
      return prev.map(record =>
        isSameDocumentId(record.id, updatedDocument.id) ? { ...record, ...updatedDocument } : record
      )
    })
  }

  const onClose = () => {
    dispatch(updateProdDetailsAttachments(null))

    props.setShowCertificateDetails(false)
    setFlyoutWidth(initialFlyOutWidth)
    setPartiesData(null)
    setDecisionSummaryData(null)
    setPartiesAttribute(null)
    setAttachmentsV2(null)
    setRPAttachments([])
    setRPAttachmentsV2(null)
    setHasCertificateBeenActive(false)
  }

  const hasPendingTestReportFailedStatus =
    attachmentsV2 &&
    Object.values(attachmentsV2).some(attachment =>
      attachment?.records?.some(
        record => record.status === CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed
      )
    )

  const isExpanded: boolean = flyoutWidth !== initialFlyOutWidth
  const loadingIndicator = (
    <FontAwesomeIcon
      title="Fetching Data"
      icon={faSpinner}
      size={'1x'}
      spin={true}
      className={clsx(classes['icons'], classes['icons-ml'])}
    />
  )

  const partiesTabHeader = <>Parties {partiesData == null && loadingIndicator}</>

  const attachmentTabHeader = <>Attachments {!isAttachmentLoaded && loadingIndicator}</>

  const requestPartyValue = async (key: string, value: string) => {
    const dropdownRequest = await CertificateListService.getIpAttributesDropdownList(key, value)

    return dropdownRequest
  }

  const getDecisionSummary = async (
    certScheme: string,
    hierarchyId: string,
    isDecision: boolean
  ) => {
    const result = await CertificateListService.getCertifcateDecisionSummary(
      certScheme,
      hierarchyId,
      true,
      isDecision
    )

    if (result && result.length > 0) setDecisionSummaryData(result[0])
  }

  const getParties = async (certScheme: string, hierarchyId: string, editData: any) => {
    const result = await CertificateListService.getCertifcateParties(certScheme, hierarchyId)

    if (result && result.length > 0) {
      setPartiesAttribute(result[0])
      const editDataCopy = structuredClone(editData)
      for (const partyAttr of result[0]?.cert_attributes) {
        for (const dataToEdit of editData) {
          let partyAttributeName = CertificateDetailsUtils.getPartyAttributeName(
            partyAttr?.attribute_name
          )
          if (partyAttributeName === dataToEdit?.attribute_name) {
            for (const [index, attributeValue] of Object.entries<any>(dataToEdit.value)) {
              const resultPartyValue = await requestPartyValue(
                partyAttr?.attribute_name,
                attributeValue
              )

              if (resultPartyValue && resultPartyValue?.length > 0) {
                editDataCopy
                  ?.find((copyEdit: any) => copyEdit?.attribute_name === partyAttributeName)
                  .value.splice(index, 1, resultPartyValue[0]?.name)
              }
            }
          }
        }
      }

      setPartiesData(editDataCopy)
    }
  }

  const getAttachments = async (uniqueCertificateId: string) => {
    if (!uniqueCertificateId) return
    const attachments =
      await CertificateListService.getCertificateDocumentsByUniqueCertificateId(uniqueCertificateId)

    setAttachments(attachments?.data)
    setIsAttachmentLoaded(true)
  }

  const getAttachmentById = async (attachmentId: string) => {
    if (!attachmentId) return
    const result = await CertificateListService.getCertificateDocumentsByDocumentId(attachmentId)

    if (result?.data != null) {
      let documentAttachments = attachmentsV2?.[result?.data.documentType] ?? null

      if (documentAttachments?.records != null) {
        documentAttachments.records = documentAttachments.records.map((record: any) => {
          if (record.id === result.data.id) {
            return result.data
          }
          return record
        })

        const updatedAttachments = attachmentsV2
        updatedAttachments![result.data.documentType] = documentAttachments
        setAttachmentsV2(updatedAttachments)
      }
    }
  }

  const initialAttachment = async (uniqueCertificateId: string) => {
    if (!uniqueCertificateId) return

    const documentTypes = Object.values(CertificateDocumentType).filter(
      (v): v is CertificateDocumentType => typeof v === 'number'
    )

    const attachments: Record<CertificateDocumentType, any> =
      attachmentsV2 ??
      documentTypes.reduce(
        (acc, key) => {
          acc[key] = null
          return acc
        },
        {} as Record<number, any>
      )

    await Promise.all(
      documentTypes.map(async documentType => {
        const data = {
          certificateId: uniqueCertificateId,
          documentType,
          take: 10,
          skip: 0,
          sort: null,
          sortBy: null,
          searchString: '',
        }

        const result = await CertificateListService.getCertificateDocumentsPaginated(data)

        attachments[documentType] = result?.data ?? null
      })
    )

    setAttachmentsV2(attachments)
    setIsAttachmentLoaded(true)
  }

  const getAttachmentsByDocumentType = async (
    uniqueCertificateId: string,
    documentType: CertificateDocumentTypeV2,
    pageNumber: number = 1,
    pageCount: number = 10
  ) => {
    if (!uniqueCertificateId) return
    setIsFetchingData(documentType)

    const attachments: AttachmentsV2Type =
      attachmentsV2 ??
      Object.values(CertificateDocumentType)
        .filter((v): v is CertificateDocumentType => typeof v === 'number')
        .reduce<Record<CertificateDocumentType, {}>>(
          (acc, key) => {
            acc[key] = {}
            return acc
          },
          {} as Record<CertificateDocumentType, {}>
        )

    let documentAttachments = attachments?.[documentType] ?? null
    const skip = (pageNumber - 1) * pageCount
    const data = {
      certificateId: uniqueCertificateId,
      documentType: documentType,
      take: pageCount,
      skip: skip,
      sort: null,
      sortBy: null,
      searchString: '',
    }

    const result = await CertificateListService.getCertificateDocumentsPaginated(data)

    if (documentAttachments?.records != null) {
      documentAttachments.records.push(...result?.data?.records)
      documentAttachments.pageNumber = pageNumber
      documentAttachments.hasNextPage = result?.data?.hasNextPage
      attachments[documentType] = documentAttachments
    } else {
      attachments[documentType] = result?.data
    }

    setAttachmentsV2(attachments)
    setIsFetchingData(null)
  }

  const getRPAttachments = async (uniqueCertificateId: string) => {
    if (!uniqueCertificateId) return

    const rpAttachments =
      await CertificateListService.getCertificateRPDocumentsByUniqueCertificateId(
        uniqueCertificateId
      )

    const transformData = AddAttachmentsRPUtils.mapCertificateAttachmentsToRPModel(
      rpAttachments?.data
    )

    setRPAttachments(transformData)
  }

  const getRPAttachmentsByDocumentType = async (
    uniqueCertificateId: string,
    pageNumber: number = 1,
    pageCount: number = 10
  ) => {
    if (!uniqueCertificateId) return

    setIsFetchingRPData(true)

    const data = {
      certificateId: uniqueCertificateId,
      take: pageCount,
      skip: (pageNumber - 1) * pageCount,
      sort: null,
      sortBy: null,
      searchString: '',
    }

    const result = await CertificateListService.getCertificateRPDocumentsPaginated(data)

    const transformedData = AddAttachmentsRPUtils.mapPaginatedCertificateAttachmentsToRPModel(
      result?.data
    )

    setRPAttachmentsV2((current: any) => {
      if (pageNumber === 1 || !current) {
        return transformedData
      }

      return {
        ...transformedData,
        records: [...(current.records ?? []), ...transformedData.records],
      }
    })

    setIsAttachmentLoaded(true)
    setIsFetchingRPData(false)
  }

  const reloadRPAttachmentsPaginated = async (
    uniqueCertificateId: string,
    pageNumber: number = 1,
    pageCount: number = 10
  ) => {
    if (!uniqueCertificateId) return

    setIsFetchingRPData(true)

    let accumulatedAttachments: IPaginatedRPDocumentAttachments | null = null

    for (let currentPageNumber = 1; currentPageNumber <= pageNumber; currentPageNumber++) {
      const data = {
        certificateId: uniqueCertificateId,
        take: pageCount,
        skip: (currentPageNumber - 1) * pageCount,
        sort: null,
        sortBy: null,
        searchString: '',
      }

      const result = await CertificateListService.getCertificateRPDocumentsPaginated(data)

      const transformedData = AddAttachmentsRPUtils.mapPaginatedCertificateAttachmentsToRPModel(
        result?.data
      )

      if (!accumulatedAttachments) {
        accumulatedAttachments = transformedData
        continue
      }

      accumulatedAttachments = {
        ...transformedData,
        records: [...(accumulatedAttachments.records ?? []), ...transformedData.records],
      }
    }

    setRPAttachmentsV2(accumulatedAttachments)
    setIsAttachmentLoaded(true)
    setIsFetchingRPData(false)
  }

  const getCertificateHasBeenActive = async (certificateId: any) => {
    const result = await CertificateListService.getHasCertificateBeenActive(certificateId)
    setHasCertificateBeenActive(result?.data)
  }

  const closeIcon = <CloseIcon onCloseEvent={onClose} />
  const ExpandIconInline = () => {
    const handleExpandOnClick = () => {
      if (flyoutWidth === initialFlyOutWidth) {
        setFlyoutWidth('50vw')
        return
      }

      setFlyoutWidth(initialFlyOutWidth)
    }

    return (
      <>
        <FontAwesomeIcon
          className={classes['flyout-expand-icon']}
          icon={isExpanded ? faDownLeftAndUpRightToCenter : faUpRightAndDownLeftFromCenter}
          onClick={handleExpandOnClick}
        />
      </>
    )
  }

  const components = [
    {
      headerName: 'Details',
      components: (
        <>
          <Actions
            details={details}
            setDetails={setDetails}
            setAttachments={setAttachments}
            onDeleteCertificate={props.onDeleteCertificate}
            setShowCertificateDetails={props.setShowCertificateDetails}
            isReadOnly={props.isReadOnly}
            inputAttachments={attachments}
            certificateDetailFromE2E={certificateDetailFromE2E}
            hasPendingTestReportFailedStatus={hasPendingTestReportFailedStatus}
            rpAttachments={rpAttachments}
            setRPAttachments={setRPAttachments}
            isCOScheme={isCOScheme}
            schemeEcmType={schemeEcmType}
          />
          <UlAccordion
            multiple
            className={`${classes['certificate-details-accordion']}`}
            activeIndex={[0, 1, 2, 3]}
            id="certificate-details-accordion"
          >
            <AccordionTab
              header="General Information"
              headerClassName={`${classes['certificate-details-accordion-header']}`}
              contentClassName={`${classes['certificate-details-accordion-content']}`}
              tabIndex={0}
            >
              <DetailsV2 details={details} isRevision={false} isExpanded={isExpanded} />
            </AccordionTab>

            <AccordionTab
              header={partiesTabHeader}
              headerClassName={`${classes['certificate-details-accordion-header']}`}
              contentClassName={`${classes['certificate-details-accordion-content']}`}
              tabIndex={1}
            >
              {partiesData != null && (
                <Parties
                  requestPartyValue={requestPartyValue}
                  partiesData={partiesData}
                  partiesAttribute={partiesAttribute}
                  isExpanded={isExpanded}
                />
              )}
            </AccordionTab>

            <AccordionTab
              header="Linked Products"
              headerClassName={`${classes['certificate-details-accordion-header']}`}
              contentClassName={`${classes['certificate-details-accordion-content']}`}
              tabIndex={2}
            >
              <LinkedProductsV2 products={details?.linkedProducts} />
            </AccordionTab>

            <AccordionTab
              header={attachmentTabHeader}
              headerClassName={`${classes['certificate-details-accordion-header']}`}
              contentClassName={`${classes['certificate-details-accordion-content']}`}
              tabIndex={3}
            >
              {schemeEcmType && schemeEcmType === SchemeEcmType.RP && isAttachmentLoaded && (
                <CertificateDetailsRPAttachmentsV2
                  rpAttachments={rpAttachmentsV2}
                  setRPAttachments={setRPAttachmentsV2}
                  details={details}
                  hasCertificateBeenActive={hasCertificateBeenActive}
                  reloadAttachments={() => getRPAttachments(details.uniqueCertificateId)}
                  reloadAttachmentsV2={(pageNumber?: number, pageCount?: number) =>
                    reloadRPAttachmentsPaginated(details.uniqueCertificateId, pageNumber, pageCount)
                  }
                  getNextPage={(pageNumber: number, pageCount?: number) =>
                    getRPAttachmentsByDocumentType(
                      details.uniqueCertificateId,
                      pageNumber,
                      pageCount
                    )
                  }
                  isFetchingData={isFetchingRPData}
                />
              )}
              {(!schemeEcmType ||
                (schemeEcmType &&
                  schemeEcmType === SchemeEcmType.GMA &&
                  attachments != null &&
                  isAttachmentLoaded)) && (
                <CertificateDetailsAttachmentsV3
                  attachments={attachmentsV2}
                  isFetchingData={isFetchingData}
                  getNextPage={getAttachmentsByDocumentType}
                  setAttachments={setAttachmentsV2}
                  fetchAttachmentById={getAttachmentById}
                  fetchAttachment={getAttachments}
                  certificateDetailFromE2E={certificateDetailFromE2E}
                  details={details}
                  hideTitle={true}
                />
              )}
            </AccordionTab>
          </UlAccordion>
        </>
      ),
    },
    {
      headerName: 'Decision Summary',
      components: (
        <>
          <Actions
            details={details}
            setDetails={setDetails}
            setAttachments={setAttachments}
            onDeleteCertificate={props.onDeleteCertificate}
            setShowCertificateDetails={props.setShowCertificateDetails}
            isReadOnly={props.isReadOnly}
            inputAttachments={attachments}
            certificateDetailFromE2E={certificateDetailFromE2E}
            hasPendingTestReportFailedStatus={hasPendingTestReportFailedStatus}
            rpAttachments={rpAttachments}
            setRPAttachments={setRPAttachments}
            schemeEcmType={schemeEcmType}
          />
          <DecisionSummary decisionSummaryData={decisionSummaryData} editData={details?.editData} />
        </>
      ),
      hidden: !isDecision || !decisionSummaryData,
    },
    {
      headerName: 'Revision History',
      components: <RevisionHistory revisions={details?.revisionHistory} />,
    },
  ]

  const loadLocalAttachments = async (uniqueCertificateId: string, schemeType: SchemeEcmType) => {
    await CertificateListService.syncDocument(uniqueCertificateId)
    if (schemeType && schemeType === SchemeEcmType.RP) {
      await Promise.all([
        getRPAttachments(uniqueCertificateId),
        getRPAttachmentsByDocumentType(uniqueCertificateId),
      ])
    } else {
      await getAttachments(uniqueCertificateId)
      await initialAttachment(uniqueCertificateId)
    }
  }

  const loadSchemeDetails = async (certificateScheme: string) => {
    const schemeDetails =
      await CertificateListService.getCertificateSchemeDetailByName(certificateScheme)
    setIsCOScheme(schemeDetails?.data?.isCo ?? false)
    setSchemeEcmType(schemeDetails?.data?.schemeEcmType)
    setIsDecision(schemeDetails?.data?.isDecision ?? false)
  }

  const getDetails = async (selectedCertificateId: string) => {
    setIsFetchingCertificateDetails(true)
    let details: any
    let certificateDetailFromE2E: any

    await Promise.allSettled([
      CertificateListService.getCertificateDetails(selectedCertificateId).then(response => {
        details = response
        dispatch(updateServiceRequestNumber(details?.certificateDetails?.serviceRequestNumber))
      }),
      CertificateListService.getCertificateDetailByWorkbenchCertificateId(
        selectedCertificateId
      ).then(response => {
        certificateDetailFromE2E = response
      }),
    ])

    if (certificateDetailFromE2E?.data != null) {
      setCertificateDetailFromE2E(certificateDetailFromE2E?.data)
    }

    let schemeEcmType = certificateDetailFromE2E?.data?.schemeEcmType
    let isDecisionSummary = certificateDetailFromE2E?.data?.isDecision
    if (certificateDetailFromE2E?.data == null || !schemeEcmType || !isDecisionSummary) {
      loadSchemeDetails(details?.certificateScheme)
    } else {
      setSchemeEcmType(schemeEcmType)
      setIsDecision(isDecisionSummary)
      setCertificateDetailFromE2E(certificateDetailFromE2E?.data)
    }

    await getCertificateHasBeenActive(selectedCertificateId)

    if (isDecisionSummary && isDecisionSummary === true) {
      const certScheme = details?.certificateScheme ?? ''
      const hierarchyId = details?.hierarchyId ?? ''
      await getDecisionSummary(certScheme, hierarchyId, isDecisionSummary)
    }

    details.certificateId = selectedCertificateId
    details.localData = details.localData && JSON.parse(details.localData)[0]
    ifECMClearTheOldAttachmentImplementation(details.localData)
    setDetails(details)
    setIsFetchingCertificateDetails(false)

    getParties(details?.certificateScheme ?? '', details?.hierarchyId ?? '', details?.editData)

    loadLocalAttachments(details?.uniqueCertificateId, schemeEcmType)
  }

  const ifECMClearTheOldAttachmentImplementation = (data: any) => {
    if (data && data.attachments) data.attachments = null
  }

  useEffect(() => {
    if (!attachments) return

    setAttachmentsV2(prev => {
      if (!prev) return prev

      const newObject = _.cloneDeep(prev)

      for (const [key, value] of Object.entries(newObject)) {
        if (!value.records) continue

        value.records = value.records.map(record => {
          const attachment = attachments.find(x => x.id === record?.id)
          if (attachment && attachment.status !== record.status) {
            return { ...record, ...attachment }
          }
          return record
        })
      }

      return newObject
    })
  }, [attachments])

  useEffect(() => {
    if (!rpAttachments || !rpAttachmentsV2?.records) return

    const newAttachments = rpAttachmentsV2.records.map(
      (attachmentV2: IAddAttachmentsRPTestReportModel) => {
        const currentState = rpAttachments.find(
          (attachment: IAddAttachmentsRPTestReportModel) => attachment.id === attachmentV2.id
        )

        const supportingDocumentState = attachmentV2?.supportingDocuments?.map(
          (supportingDoc: IAddAttachmentsRPTestSupportingDocumentModel) => {
            const currentSupportingState = currentState?.supportingDocuments?.find(
              (attachment: IAddAttachmentsRPTestSupportingDocumentModel) =>
                attachment.id === supportingDoc.id
            )

            return {
              ...supportingDoc,
              status: currentSupportingState?.status ?? supportingDoc.status,
            }
          }
        )

        return {
          ...attachmentV2,
          status: currentState?.status ?? attachmentV2.status,
          supportingDocuments: supportingDocumentState ?? attachmentV2.supportingDocuments,
        }
      }
    )

    setRPAttachmentsV2({
      ...rpAttachmentsV2,
      records: newAttachments,
    })
  }, [rpAttachments])

  useEffect(() => {
    if (selectedCertificateId) {
      getDetails(selectedCertificateId)
      dispatch(reloadCertificateDetails(false))
    }
  }, [selectedCertificateId])

  useEffect(() => {
    if (isReloadDetails) {
      getDetails(selectedCertificateId)
      dispatch(reloadCertificateDetails(false))
    }
  }, [isReloadDetails])

  return (
    <Sidebar
      visible={props.showCertificateDetails}
      position="right"
      dismissable={true}
      className={`details-font ${classes['certificate-details-layout']}`}
      onHide={onClose}
      showCloseIcon={false}
      style={{ width: flyoutWidth }}
    >
      {isFetchingCertificateDetails && (
        <div className={`${classes['loading-container']}`}>
          <div>Retrieving certificate details......</div>
          <div>
            <svg className="ul-progressCircle -medium">
              <circle className="ul-progressCircle__outer" cx="50%" cy="50%" r="35%" />
              <circle className="ul-progressCircle__inner" cx="50%" cy="50%" r="35%" />
            </svg>
          </div>
        </div>
      )}
      {!isFetchingCertificateDetails && (
        <>
          <Header closeIcon={closeIcon} details={details} expandIcon={<ExpandIconInline />} />

          <ULTabs
            containerClassName={`${classes['ul-tab-container']}`}
            contentClassName={`${classes['ul-tab-content']}`}
            components={components}
          />
        </>
      )}
    </Sidebar>
  )
}

export default CertificateDetailsV2
